import customerAnalytics from '@glovo/customer-analytics'
import DynamicSession = customerAnalytics.com.glovoapp.analytics.dynamicsession.DynamicSession
import Events = customerAnalytics.com.glovoapp.analytics.events
import Analytics = customerAnalytics.com.glovoapp.analytics

export const analytics = customerAnalytics.com.glovoapp.analytics
export const analyticsEvents = analytics.events
export const AnalyticsServiceFactory = analytics.AnalyticsServiceFactory

export type AnalyticsDelegate = customerAnalytics.com.glovoapp.analytics.AnalyticsDelegate
export type DynamicSessionType =
  customerAnalytics.com.glovoapp.analytics.dynamicsession.DynamicSession
export { Events, Analytics, DynamicSession }
